import { lazy } from 'react';
var PAY_PAGE = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '15',
];
var PAY_ROUTES = PAY_PAGE.map(function (obj) { return ({
    path: "/PAY00/PAY000" + obj,
    component: lazy(function () { return import("view/Project/PAY/PAY000" + obj); }),
}); });
export default PAY_ROUTES;
